module.exports = __webpack_public_path__ + "img/application_bg1.75233fd5.jpg";